/* eslint-disable @typescript-eslint/indent */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-param-reassign */
/**
 *
 * Component: MultipleFilter
 * Date: 7/8/2020
 *
 */

import React, { useState, useEffect } from 'react';
import _ from 'lodash';

import MultiSelectFilter from 'components/MultiSelectFilter';
import { Icon, Text } from 'components/common';

import styles from './style.module.css';

function MultipleFilter({
  handleClear,
  filter,
  selectedValues,
  filterValues,
  onFilterApplied,
  moreFilter,
  setShowMoreFilter,
  ...rest
}: any) {
  const [selectedValuesState, setSelectedValuesState] = useState(
    _.cloneDeep(selectedValues),
  );

  useEffect(() => {
    setSelectedValuesState(selectedValues);
  }, [selectedValues]);

  /**
   * For All selected values from filter, generates an appropriate filter object, with condition like 'in' or 'not in and all selected values.
   * */
  const onTagValueChange =
    (index: string | number) =>
    (key: string | number, selectedValuesArgs: any, condition: any) => {
      // eslint-disable-next-line @typescript-eslint/indent
      const appliedCondition: any = {};
      let newSelectedValues = _.cloneDeep(selectedValuesState);
      newSelectedValues[index] = { value: selectedValuesArgs, condition };
      newSelectedValues = cleanSelectedFilter(newSelectedValues);
      setSelectedValuesState(newSelectedValues);
      appliedCondition[key] = 'multiple';
      onFilterApplied(key, newSelectedValues, appliedCondition);
    };

  /**
   * A simple array filter functions based on value key having some length.
   * */
  const cleanSelectedFilter = (selectedFilter: any[]) => {
    return selectedFilter.filter(
      (s: { value: string | any[] }) => s.value?.length > 0,
    );
  };

  /**
   * May be pending to be implemented, but shall handle Outside clicks.
   * */
  const handleClickOutside = () => {};
  return (
    <div className={styles.container}>
      {moreFilter && <Text type="subtitle" text={filter.name} />}
      <div className="grid-column">
        <div className={styles.buttonsContainer}>
          {
            // "selectedValuesState?.length === 1 && !moreFilter" this condition in when there is no condition in multiple and user wants to access this from top filters, so this should work as multiselect filters with selected values etc
          }
          {(moreFilter || (selectedValuesState?.length === 1 && !moreFilter)) &&
            selectedValuesState.map(
              (af: { condition: any; value: any }, i: number) => (
                <>
                  <MultiSelectFilter
                    {...rest}
                    moreFilter
                    hideTitle
                    handleClear={handleClear}
                    filter={filter}
                    handleClickOutside={handleClickOutside}
                    filterKeyId={filter.field}
                    condition={af.condition || 'in'}
                    filterValues={filterValues}
                    onFilterApplied={onTagValueChange(i)}
                    selectedValues={af.value || [af]}
                    showConditionOption
                  />
                  {1 + i !== selectedValuesState.length && (
                    <Text
                      className="HeadersOrange filter-gray"
                      text="AND"
                      type="none"
                    />
                  )}
                </>
              ),
            )}
          {((selectedValuesState?.length !== 1 && !moreFilter) ||
            moreFilter) && (
            <MultiSelectFilter
              {...rest}
              moreFilter={moreFilter}
              hideTitle
              multiSelectFilter
              handleClear={handleClear}
              filter={filter}
              setShowMoreFilter={setShowMoreFilter}
              handleClickOutside={handleClickOutside}
              filterKeyId={filter.field}
              condition="in"
              filterValues={filterValues}
              onFilterApplied={onTagValueChange(selectedValuesState.length)}
              selectedValues={moreFilter ? [] : selectedValuesState}
              showConditionOption
            />
          )}
        </div>
        {moreFilter && selectedValuesState?.length > 0 && (
          <Icon
            size={12}
            onClick={() => handleClear(filter.key)}
            type="delete"
          />
        )}
      </div>
    </div>
  );
}
export default MultipleFilter;
